import { Component, OnInit, EventEmitter, Output, Input, OnChanges, SimpleChanges } from '@angular/core';
import { trigger, style, state, transition, animate } from '@angular/animations';
import { ReceiptService } from '../../../../services/receipt.service';

@Component({
    selector: 'misc-category',
    templateUrl: './category.component.html',
    styleUrls: ['./category.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                opacity: 1,
                display: 'block'
            })),
            state('closed', style({
                opacity: 0,
                display: 'none'
            })),
            transition('open => closed', [
                animate('0.5s')
            ]),
            transition('closed => open', [
                animate('0.5s')
            ]),
        ]),
    ]
})
export class CategoryComponent implements OnInit, OnChanges {
    isOpen: boolean = true;
    @Input() receiptSubTypes;
    selectedCategory = { Description:''};
    @Output() categoryObject = new EventEmitter();
    @Input() changing;
    @Output() isEnableSelectMiscAWBDetails = new EventEmitter();
    constructor(private receipt: ReceiptService) { }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['changing'] != undefined) {
            var change = changes['changing'].currentValue
            if (change == true)
                this.isOpen = change;
        }
    }
  selecteCategory(category) {
        this.selectedCategory = category;
        this.categoryObject.emit(category)
        this.isOpen = !this.isOpen;
    }

    change() {
        this.isOpen = !this.isOpen;
        this.isEnableSelectMiscAWBDetails.emit(false);
    }

    ngOnInit() {

    }

}
